import $ from '@ali/tarzan-zepto';
import BaseUI from '../../../component/baseui/index';
import template from './file-transfer-customer.html';
import './file-transfer-customer.scss';
import util from '../../../lib/util.js';

const clickType = util.isPC() ? 'click' : 'tap';

export default function fileTransferCustomer(data) {
  const VISIBLE = ' -visible';
  const renderData = Object.assign({ blockClass: 'csc-file-transfer-customer' }, data);
  const content = template.render(renderData);
  const param = {
    name: 'consumer',
    content,
    contentType: data.contentType ? ` -${data.contentType}` : '',
    side: data.side,
  };
  const $node = $(BaseUI.msg(param));
  this.view.body.scrollToBottom();

  return {
    body: $node,
    callback: ($file) => {
      const $name = $file.find('._name');
      const $nameRuler = $file.find('._name-ruler');
      const $progessPercent = $file.find('._progressPercent');
      const $download = $file.find('._download');

      if ($nameRuler.width() > $name.width()) {
        const { fileName, fileType: fileExtension } = renderData;
        const shortName = fileName.substring(0, 19); // 'file nam'
        const extensionName = `${fileName.slice(-1)}.${fileExtension}`; // 'e.pdf'
        const modifiedName = `${shortName}...${extensionName}`;
        $name.append(modifiedName);
        $download.text(modifiedName);
      } else {
        $name.append(renderData.name);
      }
      $name.addClass(VISIBLE);

      $file.on(clickType, '._cancel-button', (e) => {
        this.emit(this.events.CANCEL_UPLOAD_FILE, $(e.target).data('file-id'));
      });

      $file.on('percentChange', '._progress', (e, percent) => {
        if (percent === 100) {
          $file.find('._progress').remove();
        } else {
          $progessPercent.css('width', `${percent}%`);
        }
      });

      $file.on('uploadDone', '._name', (e, fileUrl) => {
        $download.attr('href', fileUrl).removeClass('-hidden');
      });

      $file.on(clickType, '._download', (e) => {
        e.preventDefault();
        window.open($(e.target).attr('href'), '_blank');
      });
    },
  };
}



// WEBPACK FOOTER //
// ./src/app/extension/file-transfer-customer/file-transfer-customer.js